import { defineMessages } from 'react-intl';
export default defineMessages({
  rateCourseTitle: {
    id: "CourseReviewForm.rateCourseTitle",
    defaultMessage: [{
      "type": 0,
      "value": "How would you rate this course?"
    }]
  },
  currentCourseRatingTitle: {
    id: "CourseReviewForm.currentCourseRatingTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Your current course rating"
    }]
  },
  courseRatingLabel: {
    id: "CourseReviewForm.courseRatingLabel",
    defaultMessage: [{
      "type": 0,
      "value": "How likely would you recommend this course to your colleagues?"
    }]
  },
  courseRatingFeedback: {
    id: "CourseReviewForm.courseRatingFeedback",
    defaultMessage: [{
      "type": 0,
      "value": "Feedback"
    }]
  },
  likelyLabel: {
    id: "CourseReviewForm.likelyLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Likely"
    }]
  },
  notLikelyLabel: {
    id: "CourseReviewForm.notLikelyLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Not likely"
    }]
  },
  saveAndContinueLabel: {
    id: "CourseReviewForm.saveAndContinueLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Save and continue"
    }]
  },
  skipLabel: {
    id: "CourseReviewForm.skipLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Skip"
    }]
  },
  closeLabel: {
    id: "CourseReviewForm.closeLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Close"
    }]
  },
  leaveRatingSuccess: {
    id: "CourseReviewForm.leaveRatingSuccess",
    defaultMessage: [{
      "type": 0,
      "value": "Thanks for your rating!"
    }]
  },
  maxLength: {
    id: "General.maxLength",
    defaultMessage: [{
      "type": 0,
      "value": "Maximum length is "
    }, {
      "type": 1,
      "value": "maxCharsQnt"
    }, {
      "type": 0,
      "value": " characters"
    }]
  }
});